import { useIpQuery } from '@features/auth/api/auth-api';
import { useCurrentIp } from '@features/auth/slices/ip-slice';

const UPDATE_IP_INTERVAL = 60 * 1000;

export const useUpdateIp = () => {
  const ip = useCurrentIp().toString();
  useIpQuery(ip, {
    pollingInterval: UPDATE_IP_INTERVAL,
    skip: ip === 'false',
  });
};
